import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { REJECT_WEBLINK_STATUS_IN_VALIDATOR } from 'utils/serviceUrls';
import { setMessage, setNotificationType, setShowNotification } from 'slices/roleModuleSlice';
import { axiosPrivateInstance } from 'libs/axios';

import { IResDataWeblink } from 'components/common/model';

const useWeblinkReject = (isStatusSumitted: boolean, formData, updateWeblinkStatus: any) => {
	const { t } = useTranslation('l3System');
	const dispatch = useDispatch();

	const [rejectLoading, setRejectLoading] = useState<boolean>(false);
	const [resRejectStatusData, setResRejectStatusData] = useState<IResDataWeblink>();

	useEffect(() => {
		if (isStatusSumitted) {
			setRejectLoading(true);
			setResRejectStatusData(undefined);
			axiosPrivateInstance
				.post(REJECT_WEBLINK_STATUS_IN_VALIDATOR, formData)
				.then((response: any) => {
					setResRejectStatusData(response);
					if (response?.status) {
						dispatch(
							setMessage(t(response?.output?.resultText || 'WEBLINK_ACTION_SUCCESS')),
						);
						dispatch(setShowNotification(true));
						dispatch(setNotificationType('success'));
					} else {
						dispatch(
							setMessage(t(response?.output?.resultText || 'WEBLINK_ACTION_FAILED')),
						);
						dispatch(setShowNotification(true));
						dispatch(setNotificationType('error'));
					}
				})

				.catch(() => {
					setMessage(t('WEBLINK_ACTION_FAILED'));
				})
				.finally(() => {
					updateWeblinkStatus();
					setRejectLoading(false);
				});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isStatusSumitted]);

	return {
		rejectLoading,
		resRejectStatusData,
	};
};

export default useWeblinkReject;
